import { Link } from 'react-router-dom'

export default function NotFound() {
  return (
    <div className='wrapper'>
      <div className='container px-20 mx-auto py-80'>
        <div className='flex flex-col items-center justify-center gap-48'>
          <p className='text-title3-bold text-sk-default'>페이지를 찾을 수 없습니다</p>
          <div>
            <img src={require('assets/images/error.png')} alt='' className='w-[300px]' />
          </div>
          <div className='text-center'>
            <p className='text-h2-semibold text-sk-info'>
              죄송합니다 에러가 발생하였습니다
              <br />
              잠시 후 다시 시도해주세요
            </p>
          </div>
        </div>
        <div className='flex items-center justify-center py-40 sm:py-80'>
          <Link
            to={'/'}
            className='px-40 py-12 cursor-pointer select-none shrink-0 button_black rounded-8'
          >
            <p className='text-h3-semibold text-[#FFFFFF]'>메인으로 되돌아가기</p>
          </Link>
        </div>
      </div>
    </div>
  )
}
